import { persistentMap } from "@nanostores/persistent";

type CheckoutData = {
  cartId: string;
  parentOrderNo: string;
  // Cart the parentOrderNo arrived with. A stored parent link is only valid
  // for this cart — checkoutLoader ignores/clears it for any other cart
  // (2026-08-25: unrelated order T-50719_C inherited a stale parent link).
  parentOrderCartId: string;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  billingStreet: string;
  billingApartment: string;
  billingCountry: string;
  billingState: string;
  billingCity: string;
  billingZipcode: string;
  shippingFirstName: string;
  shippingLastName: string;
  shippingCompanyName: string;
  shippingStreet: string;
  shippingApartment: string;
  shippingCountry: string;
  shippingState: string;
  shippingCity: string;
  shippingZipcode: string;
  deliveryFirstName: string;
  deliveryLastName: string;
  deliveryCompanyName: string;
  deliveryStreet: string;
  deliveryApartment: string;
  // Phase B (2026-07-23): delivery address carries its country (ship-to is
  // US + CA; billing country was already here).
  deliveryCountry: string;
  deliveryCity: string;
  deliveryState: string;
  deliveryZipcode: string;
  whiteLabel: boolean;
  gift: boolean;
  shippingType:
    | "shipToMyAddress"
    | "pickup"
    | "shipToOtherAddress"
    | "oversized"
    | "multiple-calculated";
  shippingOption: string;
  billingAddressType: "shipping-address" | "billing-address";
  note: string;
  promocode: string;
};

const defaultCheckoutData: CheckoutData = {
  cartId: "",
  parentOrderNo: "",
  parentOrderCartId: "",
  phoneNumber: "",
  email: "",
  firstName: "",
  lastName: "",
  companyName: "",
  billingStreet: "",
  billingApartment: "",
  billingCountry: "",
  billingState: "",
  billingCity: "",
  billingZipcode: "",
  shippingFirstName: "",
  shippingLastName: "",
  shippingCompanyName: "",
  shippingStreet: "",
  shippingApartment: "",
  shippingCountry: "",
  shippingState: "",
  shippingCity: "",
  shippingZipcode: "",
  deliveryFirstName: "",
  deliveryLastName: "",
  deliveryCompanyName: "",
  deliveryStreet: "",
  deliveryApartment: "",
  deliveryCountry: "",
  deliveryCity: "",
  deliveryState: "",
  deliveryZipcode: "",
  whiteLabel: false,
  gift: false,
  shippingType: "pickup",
  shippingOption: "",
  billingAddressType: "billing-address",
  note: "",
  promocode: "",
};

export const $checkout = persistentMap<CheckoutData>(
  "$checkout:",
  defaultCheckoutData,
  {
    encode: JSON.stringify,
    decode: JSON.parse,
  }
);

// Helper to clear checkout data (call after successful order)
export function clearCheckoutData() {
  $checkout.set(defaultCheckoutData);
}
